/* Ultra Tablica — lekkie animacje (bez zaleznosci) */
(function () {
  if (window.__ultraTablica) return;
  window.__ultraTablica = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(root) {
    var nodes = (root || document).querySelectorAll('.ut__rv:not([data-ut-seen]),.ut__rise:not([data-ut-seen])');
    if (!nodes.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      for (var i = 0; i < nodes.length; i++) { nodes[i].classList.add('is-in'); nodes[i].setAttribute('data-ut-seen', ''); }
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    for (var j = 0; j < nodes.length; j++) { nodes[j].setAttribute('data-ut-seen', ''); io.observe(nodes[j]); }
  }

  function stagger(root) {
    var groups = (root || document).querySelectorAll('[data-ut-stagger]:not([data-ut-staggered])');
    for (var i = 0; i < groups.length; i++) {
      groups[i].setAttribute('data-ut-staggered', '');
      var kids = groups[i].children, step = parseInt(groups[i].getAttribute('data-ut-stagger'), 10) || 90;
      for (var k = 0; k < kids.length; k++) {
        kids[k].classList.add('ut__rv');
        kids[k].style.setProperty('--d', (k * step) + 'ms');
      }
    }
  }

  function anchors(root) {
    var links = (root || document).querySelectorAll('[data-ut-scroll]:not([data-ut-bound])');
    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute('data-ut-bound', '');
      links[i].addEventListener('click', function (ev) {
        var sel = this.getAttribute('data-ut-scroll');
        var target = null;
        try { target = sel && document.querySelector(sel); } catch (err) { target = null; }
        if (!target) return;
        ev.preventDefault();
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    }
  }

  function init(root) { stagger(root); reveal(root); anchors(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
